<template>
  <div v-if="totalPages > 1" class="paging">
    <RouterLink v-if="prevPageLink" :to="prevPageLink" class="paging__button -arrow" aria-label="Prochaine page">
      &lt;
    </RouterLink>

    <span v-else class="paging__button -arrow -disabled">&lt;</span>

    <template v-if="showFirstGroup">
      <RouterLink
        :to="getPageRoute(0)"
        class="paging__button"
        :class="{ '-active-page': currentPage === 1 }"
        aria-label="Page 1"
      >
        1
      </RouterLink>

      <span class="paging__ellipsis">•</span>
    </template>

    <RouterLink
      v-for="pageNumber in pageRange"
      :key="pageNumber"
      :to="getPageRoute(pageNumber - 1)"
      class="paging__button"
      :class="{ '-active-page': currentPage === pageNumber }"
      :aria-label="`Page ${pageNumber}`"
    >
      {{ pageNumber }}
    </RouterLink>

    <template v-if="showLastGroup">
      <span class="paging__ellipsis">•</span>

      <RouterLink
        :to="getPageRoute(totalPages - 1)"
        class="paging__button"
        :class="{ '-active-page': currentPage === totalPages }"
        :aria-label="`Page ${totalPages}`"
      >
        {{ totalPages }}
      </RouterLink>
    </template>

    <RouterLink v-if="nextPageLink" :to="nextPageLink" class="paging__button -arrow" aria-label="Prochaine page">
      &gt;
    </RouterLink>

    <span v-else class="paging__button -arrow -disabled">&gt;</span>
  </div>
</template>

<script>
export default {
  name: 'PagePickerQuery',
  props: {
    totalPages: { type: Number, default: 0 }
  },
  computed: {
    currentPage() {
      return parseInt(this.$route.query.page) || 1
    },
    showFirstGroup() {
      return this.totalPages > 5 && this.currentPage > 3
    },
    showLastGroup() {
      return this.totalPages > 5 && this.currentPage < this.totalPages - 2
    },
    pageRange() {
      if (this.showFirstGroup && this.showLastGroup) {
        // show three pages around current page
        return Array.from({ length: 3 }, (_, i) => this.currentPage - 1 + i)
      } else if (!this.showFirstGroup && this.showLastGroup) {
        // show first four pages
        return Array.from({ length: 4 }, (_, i) => i + 1)
      } else if (this.showFirstGroup && !this.showLastGroup) {
        // show last four pages
        return Array.from({ length: 4 }, (_, i) => i + this.totalPages - 3)
      }

      return Array.from({ length: this.totalPages }, (_, i) => i + 1)
    },
    nextPageLink() {
      return this.currentPage < this.totalPages ? this.getPageRoute(this.currentPage) : null
    },
    prevPageLink() {
      return this.currentPage > 1 ? this.getPageRoute(this.currentPage - 2) : null
    }
  },
  watch: {
    currentPage(newPage, oldPage) {
      if (newPage !== oldPage) this.$scroll.toTarget('#entry-index', 128)
    }
  },
  methods: {
    getPageRoute(index) {
      const { page, ...queryRest } = this.$route.query
      const query = !index ? queryRest : { ...queryRest, page: index + 1 }
      return { query }
    }
  }
}
</script>
